exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-input .number-piece input {\n  border: none;\n  background: #FFFFFF;\n  width: 0;\n  caret-color: transparent;\n}\n.template-input .number-piece.focused input {\n  background: #22C044;\n  color: #FFFFFF;\n}\n", ""]);
